// extracted by mini-css-extract-plugin
export default {"reminder_styles":"urgentOrder_reminder_styles__itWAy","inline":"urgentOrder_inline__3zx7Z","width-50":"urgentOrder_width-50__lYEBV"};